import { cloneDeep, get, set } from 'lodash';

// Types de champs (id de leur définition) qui proposent l'option "Champ masqué"
export const HIDDEN_CAPABLE_FIELDS = [
  'neoform-field-string-free', // Champ texte
  'neoform-field-string-dynamic-api', // Champ texte dynamique
];

const DATA_PROPERTIES_PATH = [
  'properties',
  'tabs',
  'properties',
  'data',
  'properties',
];

const hiddenProperty = {
  type: 'boolean',
  title: 'Champ masqué',
  description:
    "Le champ n'est jamais affiché, quel que soit le rôle, mais sa valeur reste dans les données du formulaire et d'autres champs peuvent en dépendre.",
};

/**
 * Ajoute la coche "Champ masqué" (tabs.data.hidden) dans l'onglet "Données" du
 * formulaire d'édition des champs compatibles. Les définitions de champs étant
 * stockées en base, l'option est ajoutée ici à l'ouverture de l'édition plutôt
 * que dans chaque définition. Côté API, `tabs.data.hidden === true` génère
 * `'ui:widget': 'hidden'`.
 *
 * @param {object} field - Le champ édité (élément du builder)
 * @param {object} jsonSchema - Le jsonSchema du formulaire d'édition
 * @returns {object} Le jsonSchema, avec l'option si le champ est compatible
 */
const withHiddenOption = (field, jsonSchema) => {
  const dataProperties = get(jsonSchema, DATA_PROPERTIES_PATH);
  if (
    !HIDDEN_CAPABLE_FIELDS.includes(field?.id) ||
    !dataProperties ||
    dataProperties.hidden
  ) {
    return jsonSchema;
  }
  const newJsonSchema = cloneDeep(jsonSchema);
  set(newJsonSchema, [...DATA_PROPERTIES_PATH, 'hidden'], hiddenProperty);
  return newJsonSchema;
};

export default withHiddenOption;
